import _extends from "@babel/runtime/helpers/esm/extends";
import { addReCaptchaSDK, buildSDKUrl } from "./loader.js";
export default class ReCaptcha {
  constructor({
    apiKey
  }) {
    this.apiKey = void 0;
    this.captchaToken = null;
    this.tokenCallback = void 0;
    this.initPromise = null;
    /**
     * Mandatory function to call in order for the module to be functionnal
     * 1. Add init callback to window
     * 2. Download reCaptcha's SDK
     * @param initParameters - options to init grecaptcha with
     */
    this.init = ({
      containerId,
      errorCallback,
      expiredCallback,
      tokenCallback: providedCallback
    }) => {
      if (this.initPromise) {
        return this.initPromise;
      }
      this.initPromise = new Promise(resolve => {
        window.initReCaptcha = () => {
          try {
            this.render(containerId, {
              'error-callback': errorCallback,
              'expired-callback': expiredCallback,
              callback: token => {
                var _this$tokenCallback;
                this.captchaToken = token;
                providedCallback == null || providedCallback(token);
                (_this$tokenCallback = this.tokenCallback) == null || _this$tokenCallback.call(this, token);
              }
            });
          } catch (_unused) {
            // Multiple render triggers error and is an ok reason to fail gracefully
          }
          this.initPromise = null;
          resolve();
        };
        addReCaptchaSDK(buildSDKUrl({
          onload: 'initReCaptcha'
        }), 'recaptcha-jssdk');
      });
      return this.initPromise;
    };
    this.getSDK = () => {
      var _window$grecaptcha;
      const reCaptchaApi = (_window$grecaptcha = window.grecaptcha) == null ? void 0 : _window$grecaptcha.enterprise;
      if (!reCaptchaApi) {
        throw new Error('Recaptcha has not been initialized yet');
      }
      return reCaptchaApi;
    };
    /**
     * Render
     *
     * This method is a thin wrapper around grecaptcha.
     * It's done by default in the init function so call it at your own risk.
     * @param container - where to render the reCaptcha enterprise
     * @param overrideParameters - init parameters you want to add and / or override
     * @param inherit - inherit data attributes on invisible only
     * @returns
     */
    this.render = (container, overrideParameters, inherit) => {
      const reCaptchaApi = this.getSDK();
      return reCaptchaApi.render(container, _extends({
        sitekey: this.apiKey,
        size: 'invisible'
      }, overrideParameters), inherit);
    };
    this.apiKey = apiKey;
  }
  getToken() {
    return this.captchaToken;
  }
  resetToken() {
    this.captchaToken = null;
  }
  reset() {
    this.getSDK().reset();
    this.resetToken();
  }
  /**
   * Execute the
   */
  execute() {
    return new Promise(res => {
      this.tokenCallback = token => {
        res(token);
      };
      this.getSDK().execute();
    });
  }
}
//# sourceMappingURL=index.js.map